import { Format } from './format.interface';
import { Card, Query } from '@deckplan.io/common';

export class Freeform extends Format {

    public addCardsQuery(): Query {
        // Freeform decks do no card filtering for cards to add
        return undefined;
    }

    public validate(): Card[] {
        // All cards are valid in "freeform"
        return [];
    }
}
